import { render, staticRenderFns } from "./AccountPrivileges.vue?vue&type=template&id=7f14bcb8&"
import script from "./AccountPrivileges.vue?vue&type=script&lang=js&"
export * from "./AccountPrivileges.vue?vue&type=script&lang=js&"
import style0 from "./AccountPrivileges.vue?vue&type=style&index=0&id=7f14bcb8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports